import type { Metadata } from "next";
import EditPlan from '@/Component/Admin/AdminPlan/EditPlan';

export const metadata: Metadata = {
    title: "Edit Plan | Connector Club",
    description: "",
};

const EditProfilePage = async ({ params }: { params: Promise<{ slug: string }>; }) => {
    const resolvedParams = await params;
    const slug = Array.isArray(resolvedParams.slug)
        ? resolvedParams.slug[0]
        : resolvedParams.slug;
    return <EditPlan slug={slug} />;
};

export default EditProfilePage;
